import { useNavigate, Link } from "react-router-dom";
import { useStore } from "../../store";
import { useEffect, useRef, useState } from "react";
import { toJS } from "mobx";
import { observer } from "mobx-react-lite";
import Button from "../../components/Button";
import moment from "moment";
import MessageModal, { MessageModalProps } from "../../components/MessageModal";
import InputModal, { InputModalProps } from "../../components/InputModal";
import Record from "./record";
import "./index.css";
import React from "react";

function MenuLogList() {
  const navigate = useNavigate();

  const { dataStore } = useStore();
  const resData = toJS(dataStore).resData;
  const [type, setType] = useState("auto");
  const dateFormat = resData.loadSettingAck?.dateFormat || "DD.MM.YYYY";
  const [isOpenRecord, setIsOpenRecord] = useState(false);

  useEffect(() => {
    dataStore.sendData({
      action: "loadLog",
      data: {
        type,
      },
    });
  }, [type]);

  let [checked, setChecked] = useState(0);

  const [saveLogModal, setSaveLogModal] = useState<InputModalProps>({
    isOpen: false,
    title: "Save log as:",
    value: "",
    onSave: (value: string) => { },
    onCancel: () => {
      setSaveLogModal((data) => ({ ...data, isOpen: false }));
    },
  });

  const [messageModal, setMessageModal] = useState<MessageModalProps>({
    isOpen: false,
    buttons: [],
    title: "",
  });

  // select log
  let onClickChooseLog = function (id: string, index: number) {
    setChecked(index);
  };

  // select type
  let onClickChooseType = function (type: string) {
    setType(type);
    setChecked(0);
    setSelectIds([]);
  };

  const logs = (resData.loadLogAck?.records || []).map((record, index) => ({
    ...record,
  }));


  // delete log
  let onClickDeleteLog = function (id: string) {
    setMessageModal({
      isOpen: true,
      buttons: [
        {
          text: "YES",
          onAction: () => {
            setMessageModal({ ...messageModal, isOpen: false });
            dataStore.sendData({
              action: "deleteLog",
              data: {
                id,
                type,
              },
            });

            setChecked(logs.length - 1 === checked ? 0 : checked);

            // 删除后刷新文件传输选中
            onChangeLogCheck(id);
          },
          style: {
            backgroundColor: '#5ede4e',
          }
        },
        {
          text: "NO",
          onAction: () => {
            setMessageModal({ ...messageModal, isOpen: false });
          },
        },
      ],
      title: "Delete this Log?",
    });
  };

  // show
  let onClickShowRecord = function () {
    dataStore.sendData({
      action: "loadLogContent",
      data: {
        id: logs[checked].id,
        type: type,
      },
    });

    setIsOpenRecord(true);
  };

  // save
  let onClickSaveRecord = function (value: string) {
    dataStore.sendData({
      action: "saveUserLog",
      data: {
        logId: logs[checked].id,
        logName: value,
        type: type,
      },
    });
  };

  // u盘状态
  const [isUSB, setIsUSB] = useState(false);
  //检测是否插入U盘
  let onClickIsAddUsb = function () {
    if (resData.loadUsbStatusAck?.usb) {
      setIsUSB(true);
      setSelectIds([]);
    } else {
      setIsUSB(false);
      setMessageModal({
        isOpen: true,
        buttons: [
          {
            text: "OK",
            onAction: () => {
              setMessageModal({ ...messageModal, isOpen: false });
              // 关闭弹窗提示
              setIsUSB(false);
              setSelectIds([]);
            },
          },
        ],
        title: "Please insert USB stick into USB slot.",
      });
    }
  };

  useEffect(() => {
    if (!resData.loadUsbStatusAck?.usb && isUSB) {
      setMessageModal({
        isOpen: true,
        buttons: [
          {
            text: "OK",
            onAction: () => {
              setMessageModal({ ...messageModal, isOpen: false });
              // 关闭弹窗提示
              setIsUSB(false);
              setSelectIds([]);
            },
          },
        ],
        title: "Please insert USB stick into USB slot.",
      });
    }
  }, [resData.loadUsbStatusAck?.usb]);

  useEffect(() => {
    // 开始传输后
    // if(sendStartFile && isUSB && resData.loadUsbFileAck?.currentCount === 1) {
    //   setMessageModal({
    //     isOpen: true,
    //     buttons: [],
    //     title: "File transfer in progress...",
    //   });
    //   setSendStartFile(false)

    // }

    if (
      isUSB &&
      resData.loadUsbFileAck?.currentCount ===
      resData.loadUsbFileAck?.totalCount &&
      resData.loadUsbFileAck?.currentCount
    ) {
      setMessageModal({
        isOpen: true,
        buttons: [
          {
            text: "OK",
            onAction: () => {
              setMessageModal({ ...messageModal, isOpen: false });
            },
          },
        ],
        title: "Export complete.",
      });
    }
  }, [resData.loadUsbFileAck?.currentCount]);

  // 具体选中了哪些
  const [selectIds, setSelectIds] = useState<string[]>([]);

  // 全选
  let onClickSelectAll = function () {
    let tmpList: string[] = [];
    logs.map((item) => {
      tmpList.push(item.id);
    });
    setSelectIds(tmpList);
  };

  // 单个选中
  let onChangeLogCheck = function (id: string) {
    let tmpList: string[] = [...selectIds] || [];
    let ids = [...selectIds];
    if (ids.indexOf(id) > -1) {
      // 如果已经选中，变为未选中
      tmpList = ids.filter((tId) => tId !== id);
    } else {
      // 未选中的变为选中
      tmpList.push(id);
    }
    setSelectIds(tmpList);
  };

  let [sendStartFile, setSendStartFile] = useState(false);
  // 导出
  let onClickExportFile = function () {
    setSendStartFile(true);
    dataStore.sendData({
      action: "exportLogFile",
      data: {
        ids: selectIds,
        type: type,
      },
    });

    setMessageModal({
      isOpen: true,
      buttons: [],
      title: "File transfer in progress...",
    });
    setSendStartFile(false);
  };

  // 反全选
  let onClickDeSelectAll = function () {
    setSelectIds([]);
  };

  let listRef = useRef<any>(null);

  // check mobile
  const [height, setHeight] = useState(0);

  function handleWindowSizeChange() {
    setHeight(listRef.current.scrollTop);
  }

  useEffect(() => {
    if (!isOpenRecord && listRef.current) {
      listRef.current.scrollTo({ top: height });
    }

    if (listRef.current) {
      listRef.current.addEventListener("scroll", handleWindowSizeChange);
      return () => {
        if (listRef.current) {
          listRef.current.removeEventListener("scroll", handleWindowSizeChange);
        }
      };
    }
  }, [isOpenRecord]);

  return (
    <>
      {!isOpenRecord ? (
        <div className="flex bg-quickStartPrimaryBgColor">
          <div className="absolute w-[1280px] h-[730px] flex">
            <div className="w-1/5 relative">
              <Button
                options={{
                  text: "Autosaved",
                  class: "bg-buttonRunBgColor text-lg px-8",
                  cb: () => onClickChooseType("auto"),
                }}
                style={{
                  padding: "0px 40px",
                  boxShadow: "4px 4px 4px  rgba(0, 0, 0, 0.3)",
                  backgroundColor: "#406F70",
                  marginLeft: "55px",
                  fontSize: "24px",
                  marginTop: "250px",
                  borderColor: type === "auto" ? "white" : "transparent",
                  borderStyle: "solid",
                  borderWidth: "2px",
                }}
              />
              <br></br>
              <br></br>
              <Button
                options={{
                  text: "My Logs",
                  class:
                    "bg-buttonRunBgColor text-lg px-8 absolute inset-0 m-auto",
                  cb: () => onClickChooseType("user"),
                }}
                style={{
                  padding: "0px 40px",
                  boxShadow: "4px 4px 4px  rgba(0, 0, 0, 0.3)",
                  backgroundColor: "#406F70",
                  marginLeft: "55px",
                  fontSize: "24px",
                  width: "200px",
                  borderColor: type === "user" ? "white" : "transparent",
                  borderStyle: "solid",
                  borderWidth: "2px",
                }}
              />
            </div>
            <div className="w-4/5 relative">
              <div className="border-4 rounded-2xl absolute inset-0 m-auto w-10/12 h-5/6 opacity-1">
                <div
                  className="h-[420px] overflow-auto m-10 pr-2 record-list-div"
                  ref={(r) => (listRef.current = r)}
                >
                  {logs?.map((item, index) => {
                    return (
                      <div
                        key={index}
                        className="text-white text-2xl h-10"
                        style={{
                          border:
                            checked === index
                              ? "2px solid white"
                              : "2px solid transparent",
                          borderRadius: "20px",
                          paddingLeft: "15px",
                          paddingTop: "2px",
                        }}
                        onClick={() => onClickChooseLog(item.id, index)}
                      >
                        {isUSB ? (
                          <div
                            className="w-4 float-left"
                            style={{
                              marginRight: "10px",
                            }}
                          >
                            <input
                              type="checkbox"
                              checked={selectIds.indexOf(item.id) > -1}
                              style={{ height: "15px", width: "15px" }}
                              onChange={() => onChangeLogCheck(item.id)}
                            />
                          </div>
                        ) : (
                          <></>
                        )}

                        <div className="float-left"
                          style={{
                            width: 400,
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            paddingRight: 20,
                          }}
                        >
                          {index + 1}.{" "}
                          {type === "auto" ? item.usedTime : item.name}
                        </div>

                        <div className="float-left">
                          {moment(item.endTime).format(`${dateFormat} h:mma`)}
                        </div>

                        {checked === index ? (
                          <div
                            onClick={() => onClickDeleteLog(item.id)}
                            className="bg-buttonDefaultBgColor flex"
                            style={{
                              alignItems: "center",
                              justifyContent: "center",
                              borderRadius: 29,
                              fontSize: 20,
                              fontWeight: 600,
                              width: 35,
                              height: 29,
                              float: "right",
                              marginRight: "15px",
                              marginTop: "2px",
                            }}
                          >
                            X
                          </div>
                        ) : null}
                      </div>
                    );
                  })}
                </div>
                <div className="absolute m-auto w-full text-center">
                  {isUSB ? (
                    <>
                      <Button
                        options={{
                          text: "Exit",
                          class: "bg-buttonRunBgColor text-2xl px-8",
                          cb: () => setIsUSB(false),
                        }}
                        style={{
                          boxShadow: "4px 4px 4px  rgba(0, 0, 0, 0.3)",
                          backgroundColor: "#406F70",
                        }}
                      />
                      <button className="w-4"></button>

                      <Button
                        options={{
                          text: "Select All",
                          class: "bg-buttonRunBgColor text-2xl px-8 ",
                          cb: () => onClickSelectAll(),
                        }}
                        style={{
                          boxShadow: "4px 4px 4px  rgba(0, 0, 0, 0.3)",
                          backgroundColor: "#406F70",
                        }}
                      />
                      <button className="w-4"></button>

                      <Button
                        options={{
                          text: "Deselect All",
                          class: "bg-buttonRunBgColor text-2xl px-8 ",
                          cb: () => onClickDeSelectAll(),
                        }}
                        style={{
                          boxShadow: "4px 4px 4px  rgba(0, 0, 0, 0.3)",
                          backgroundColor: "#406F70",
                        }}
                      />
                      <button className="w-4"></button>

                      <Button
                        options={{
                          text: "Export",
                          class: "bg-buttonRunBgColor text-2xl px-8 ",
                          cb: () => onClickExportFile(),
                        }}
                        style={{
                          boxShadow: "4px 4px 4px  rgba(0, 0, 0, 0.3)",
                          backgroundColor: "#406F70",
                        }}
                      />
                    </>
                  ) : (
                    <>
                      <Button
                        options={{
                          text: type === "auto" ? "Save" : "EDIT",
                          class: "bg-buttonRunBgColor text-2xl px-8",
                          disabled: logs.length <= 0,
                          cb: () =>
                            setSaveLogModal((data) => ({
                              ...data,
                              isOpen: true,
                              value: logs[checked].name || "New",
                              onSave: (value: string) => {
                                onClickSaveRecord(value);
                                setSaveLogModal((data) => ({
                                  ...data,
                                  isOpen: false,
                                }));
                              },
                            })),
                        }}
                        style={{
                          padding: "0px 40px",
                          boxShadow: "4px 4px 4px  rgba(0, 0, 0, 0.3)",
                          backgroundColor: "#406F70",
                        }}
                      />
                      <button className="w-16"></button>

                      <Button
                        options={{
                          text: "Show",
                          class: "bg-buttonRunBgColor text-2xl px-8 ",
                          cb: () => onClickShowRecord(),
                          disabled: logs.length <= 0,
                        }}
                        style={{
                          padding: "0px 40px",
                          boxShadow: "4px 4px 4px  rgba(0, 0, 0, 0.3)",
                          backgroundColor: "#406F70",
                        }}
                      />
                      <button className="w-16"></button>

                      <Button
                        options={{
                          text: "Export",
                          class: "bg-buttonRunBgColor text-2xl px-8 ",
                          cb: () => onClickIsAddUsb(),
                          disabled: logs.length <= 0,
                        }}
                        style={{
                          padding: "0px 40px",
                          boxShadow: "4px 4px 4px  rgba(0, 0, 0, 0.3)",
                          backgroundColor: "#406F70",
                        }}
                      />
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>

          <MessageModal {...messageModal} />
          {saveLogModal.isOpen && <InputModal {...saveLogModal} />}
          <Button
            options={{
              text: "RETURN",
              class: "bg-buttonRunBgColor text-lg px-8 absolute inset-0 m-auto",
              cb: () => navigate(-1),
            }}
            style={{
              padding: "0px 40px",
              boxShadow: "4px 4px 4px  rgba(0, 0, 0, 0.3)",
              backgroundColor: "#406F70",
              marginLeft: "55px",
              fontSize: "24px",
              top: "0",
              marginTop: "630px",
              width: "200px",
            }}
          />
        </div>
      ) : undefined}

      {resData.loadLogContentAck && isOpenRecord ? (
        <Record
          options={{
            cb: () => {
              setIsOpenRecord(false);
              dataStore.setNav({ title: "Logs" });
            },
            type: type,
          }}
        />
      ) : null}
    </>
  );
}
export default observer(MenuLogList);
